<template>
  <div>
    <div
      v-if="!hideAccountPausedNotification && isAdmin"
      class="top-alert-box top-alert-box-danger top-alert-box--center top-alert-box--small slide-down slide-down--medium-duration"
    >
      <span
        v-html="$t('ACCOUNT_BILLING_PAUSED')"
      />

      <span
        @click="onCloseAccountPausedNotification()"
      >
        <i
          class="fa fa-times-circle top-alert-box__centered_close"
        />
      </span>
    </div>

    <div
      v-if="!hideUploadKycNotification && isAdmin"
      class="top-alert-box top-alert-box-danger top-alert-box--center top-alert-box--small slide-down slide-down--medium-duration"
      :class="hideAccountPausedNotification ? '' : 'm-t-47'"
    >
      <span
        v-html="$t('UPLOAD_KYC_NOTIFICATION_MESSAGE')"
      />

      <span
        @click="this.onCloseKycNotification"
      >
        <i
          class="fa fa-times-circle top-alert-box__centered_close"
        />
      </span>
    </div>
  </div>
</template>

<script>
import messages from './locales';
import sharedMessages from '@/core/locales';
import { accountsService, billingService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { mapGetters } from 'vuex';

export default {
  name: 'NotificationBanner',
  data() {
    return {
      hideAccountPausedNotification: true,
      hideUploadKycNotification: true
    }
  },
  computed: {
    currentAccountIsPaused() { return accountsService.currentAccountIsPaused; },
    ...mapGetters(['isAdmin']),
  },
  async created() {
    if (this.isAdmin) {
      this.checkToShowAccountPausedNotification();
      this.getKycNotificationSettings();
    }
  },
  methods: {
    onCloseKycNotification() {
      billingService.setUploadKycNotificationSettings(true);
      this.hideUploadKycNotification = true;  
    },
    onCloseAccountPausedNotification() {
      this.hideAccountPausedNotification = true;
    },
    checkToShowAccountPausedNotification() {
      this.hideAccountPausedNotification = !this.currentAccountIsPaused;
    },
    getKycNotificationSettings() {
      billingService.checkUploadKycNotificationSettings(accountsService.currentAccountId);
      if (billingService.uploadKycNotificationSettings && typeof billingService.uploadKycNotificationSettings.hideUploadKycNotification === 'boolean') {
        this.hideUploadKycNotification = billingService.uploadKycNotificationSettings.hideUploadKycNotification;
      }
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>